import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { grpc } from '@improbable-eng/grpc-web';

import {
  AddMemberRequest,
  AddMemberResponse,
  ListMembersRequest,
  ListMembersResponse,
  RemoveMemberRequest,
  RemoveMemberResponse,
} from '../user_list/user_list_member_pb';

import {
  UserListsMember as __UserListsMember,
} from '../user_list/user_list_member_pb_service';

@Injectable({providedIn: 'root'})
export class UserListsMember {

  constructor(private _ngZone: NgZone) {
  }

  listUserListMembers(request: ListMembersRequest): Promise<ListMembersResponse>;
  listUserListMembers(request: ListMembersRequest, metadata: grpc.Metadata): Promise<ListMembersResponse>;
  listUserListMembers(request: ListMembersRequest, callback: (err: any|null, response: ListMembersResponse, metadata: grpc.Metadata) => void): void;
  listUserListMembers(request: ListMembersRequest, metadata: grpc.Metadata, callback: (err: any|null, response: ListMembersResponse, metadata: grpc.Metadata) => void): void;

  listUserListMembers(request: ListMembersRequest, arg1?: grpc.Metadata|((err: any|null, response: ListMembersResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: ListMembersResponse, metadata: grpc.Metadata) => void): Promise<ListMembersResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<ListMembersResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__UserListsMember.ListUserListMembers, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  addUserListMember(request: AddMemberRequest): Promise<AddMemberResponse>;
  addUserListMember(request: AddMemberRequest, metadata: grpc.Metadata): Promise<AddMemberResponse>;
  addUserListMember(request: AddMemberRequest, callback: (err: any|null, response: AddMemberResponse, metadata: grpc.Metadata) => void): void;
  addUserListMember(request: AddMemberRequest, metadata: grpc.Metadata, callback: (err: any|null, response: AddMemberResponse, metadata: grpc.Metadata) => void): void;

  addUserListMember(request: AddMemberRequest, arg1?: grpc.Metadata|((err: any|null, response: AddMemberResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: AddMemberResponse, metadata: grpc.Metadata) => void): Promise<AddMemberResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<AddMemberResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__UserListsMember.AddUserListMember, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  removeUserListMember(request: RemoveMemberRequest): Promise<RemoveMemberResponse>;
  removeUserListMember(request: RemoveMemberRequest, metadata: grpc.Metadata): Promise<RemoveMemberResponse>;
  removeUserListMember(request: RemoveMemberRequest, callback: (err: any|null, response: RemoveMemberResponse, metadata: grpc.Metadata) => void): void;
  removeUserListMember(request: RemoveMemberRequest, metadata: grpc.Metadata, callback: (err: any|null, response: RemoveMemberResponse, metadata: grpc.Metadata) => void): void;

  removeUserListMember(request: RemoveMemberRequest, arg1?: grpc.Metadata|((err: any|null, response: RemoveMemberResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: RemoveMemberResponse, metadata: grpc.Metadata) => void): Promise<RemoveMemberResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<RemoveMemberResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__UserListsMember.RemoveUserListMember, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

}

